export const SUCCESS_MESSAGE = 'Message saved Successfully';
export const ATHENA = 'ATHENA';
export const PARTNER_TYPES = {
	SHIPPER: 'Shipper',
	CONSIGNEE: 'Consignee',
	INVOICEE: 'Invoicee',
};